/**
 * ServiceListItemStore * Extends the BaseStore for managing ServiceListItem.
 */

import BaseStore from '@legacy-src/Datastores/BaseStore';
import { ServiceListItemInterface } from '@sah/Classes/ServiceListItem';

class ServiceListItemStore extends BaseStore<ServiceListItemInterface> {}

export default new ServiceListItemStore();
